<template>
	<div class="goods-main-div">
		<div v-show="asinInfo" v-if="asinInfo">
			<div class="goods-imgs">
				<el-carousel height="85px" indicator-position="none">
					<el-carousel-item v-for="(item,index) in JSON.parse(asinInfo.imgs)" :key="index">
						<el-image style="width: 85px; height: 85px;"  :preview-src-list="[item]" :src="item" fit="cover"></el-image>
					</el-carousel-item>
				</el-carousel>
			</div>
			
			<div class="goods-title">
				<span class="title">{{ asinInfo.title }}</span>
				<div class="categorys-div" v-if="asinInfo.categorys"> 
					<font class="info-text" :key="index"
						v-for="(item,index) in JSON.parse(asinInfo.categorys)">
						{{ item }}
						<i class="el-icon-arrow-right" 
							v-if="JSON.parse(asinInfo.categorys).length != index + 1"></i>
					</font>
				</div>
				
				<div class="goods-desc">
					<!-- 徽章标记 -->
					<asin-badge-sub :asinInfo="asinInfo"></asin-badge-sub>
						
					<font style="margin-left: 5px;" v-if="asinInfo.asin">
						<font class="info-text">
							{{ asinInfo.asin}}
							<copy-sub :value="asinInfo.asin"></copy-sub>
							<a target="_blank" :href="asinInfo.url" class="asin-target">
								<i class="el-icon-paperclip"></i>
							</a>
							
						</font>
						
					</font>
					
					<font class="goods-font" v-if="asinInfo.price">
						价格:
						<font class="info-text"  v-if="asinInfo.price">
							{{ getSymbolByCurrency(asinInfo.currency) }} 
							{{ asinInfo.price }}
						</font>
					</font>
					
					<font class="goods-font" v-if="asinInfo.score">
						评分:
						<font class="info-text"  v-if="asinInfo.score">
							{{ asinInfo.score }}
						</font>
					</font>
					
					<font class="goods-font" v-if="asinInfo.commentNum">
						评分数:
						<font class="info-text"  v-if="asinInfo.commentNum">
							{{ asinInfo.commentNum }}
						</font>
					</font>
					
					<font class="goods-font" v-if="asinInfo.uploadTime">
						上架时间:
						<font class="info-text" >
							{{ $timezone(asinInfo.uploadTime,'yyyy-MM-DD') }}
						</font>
					</font>
					
					<font class="goods-font" v-if="asinInfo.seller">
						卖家:
						<font class="info-text" >
							{{ asinInfo.seller }}
						</font>
					</font>
					
					<font class="goods-font" v-if="asinInfo.distributionMode">
						配送方式:
						<font class="info-text" >
							{{ asinInfo.distributionMode}}
						</font>
					</font>
				</div>
			</div>	
		</div>
	</div>
</template>

<script>
import { getSymbolByCurrency } from '@/components/config/countryCodeConfig.js'
import ASIN_BADGE_SUB from '@/components/template/view/keyword/monitoring/asinInfo/sub/badgeSub.vue'
import COPY_SUB from '@/components/template/otherSub/copySub.vue'

export default {
	name: 'goodsInfoSub',
	inject: ['F_alertMsg','F_windowLoading','F_getErrMSg'],
	props:{
		asinInfo : {
			required:true
		}
	},
	components:{
		'asin-badge-sub' : ASIN_BADGE_SUB,
		'copy-sub' : COPY_SUB
	},
	data() {return {
		
	}},
	created() {
	},
	methods:{
		getSymbolByCurrency: function(val){
			return getSymbolByCurrency(val)
		},
	},
}
</script>

<style scoped>
.goods-main-div{
	color: #606266;;
	padding: 20px;
	border-radius: 5px;
	border: 1px solid #ededed;
}
.goods-main-div:after{/*伪元素是行内元素 正常浏览器清除浮动方法*/
	content: "";
	display: block;
	height: 0;
	clear:both;
	visibility: hidden;
}
.goods-main-div .goods-imgs{
	width: 85px;
	height: 85px;
	float: left;
}
.goods-main-div .goods-title{
	margin-left: 110px;
	padding-top: 5px;
}
.goods-main-div .goods-title .title{
	width: 95%;
	font-size: 16px;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.goods-main-div .goods-title .categorys-div{
	color: #a8a8a8;
	font-size: 14px;
	margin-top: 10px;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.goods-desc{
	color: #a8a8a8 !important;
	font-size: 13px;
	margin-top: 10px;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
}
.goods-desc .goods-font{
	margin-left: 20px;
}
.info-text .asin-target{
	color: #a8a8a8 ;
	margin-left: 3px;
}
.info-text .asin-target:hover{
	color: red ;
}
</style>
